// extracted by mini-css-extract-plugin
module.exports = {"container":"Video_container__1JLOK","inner":"Video_inner__3lz6g","video":"Video_video__3-KUe","image":"Video_image__3kYJh"};